import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function An9(props) {
    const { nodes } = useGLTF('3ds/an/An9.glb');
    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.An9) {
                        global.gw.geometries.An9 = e.geometry;
                    }
                }}
                name="An9"
                geometry={nodes.An9.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/An9.glb');